export default __webpack_public_path__ + "static/media/power.e5edd5e6.svg";